/**
 * @desc 异常调拨
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(
  params: API.fulfilment.inPlanMaster.abnormalTransfers.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/inPlanMaster/abnormalTransfers`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
